import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import blueGrey from '@material-ui/core/colors/blueGrey';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import * as Actions from '../actions/imstat';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ImstatScenarioFactory, {
	IFetchQuestionnaireHistoryParam,
} from '../scenario/ImstatScenarioFactory';
import { Routes, Screens } from '../utils/Routes';

const styles = (theme: Theme) =>
	createStyles({
		paper: {
			margin: theme.spacing(2),
			padding: theme.spacing(2),
		},
		selectedRow: {
			background: `${theme.palette.secondary.light} !important`,
			color: `${theme.palette.secondary.contrastText} !important`,
		},
		subComponent: {
			borderLeftColor: blueGrey[100],
			borderLeftStyle: 'solid',
			borderLeftWidth: theme.spacing(1),
			marginBottom: theme.spacing(2),
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			paddingLeft: theme.spacing(1),
		},
	});

interface IRouteParams {
	career_id: string;
	class_id: string;
}

// tslint:disable-next-line: no-empty-interface
interface IRouteState {}

/**
 * テストアンケート履歴
 */
class TestQuestionnaireHistory extends React.Component<IProps> {
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerId = this.props.match.params.career_id;
		const classId = this.props.match.params.class_id;
		this.props.fetchQuestionnaireHistory(this.props.token, {
			careerId,
			classId,
		});
	}

	public componentWillUnmount() {
		this.props.resetQuestionnaireHistoryData();
	}

	public render() {
		const { classes } = this.props;
		const columns = this.getAllColumns();

		return (
			<>
				<Paper className={classes.paper}>
					<Typography>
						{i18n.t('TestQuestionnaireHistory_0001')}
					</Typography>
					<ReactTable
						data={this.props.data}
						columns={columns}
						defaultPageSize={5}
						SubComponent={this.subComponent}
					/>
				</Paper>
			</>
		);
	}

	/**
	 * 表のサブコンポーネント
	 */
	protected subComponent = (row: RowInfo) => {
		if (row.original.historyList.length === 0) {
			return (
				<div className={this.props.classes.subComponent}>
					<Typography>
						{i18n.t('TestQuestionnaireHistory_0002')}
					</Typography>
				</div>
			);
		}

		const historyColumns = this.getHistoryColumns(row.original);
		const defaultPageSize = 100;
		if (row.original.historyList.length < defaultPageSize) {
			return (
				<div className={this.props.classes.subComponent}>
					<ReactTable
						data={row.original.historyList}
						columns={historyColumns}
						defaultPageSize={row.original.historyList.length}
						className="-striped -highlight"
						showPagination={false}
					/>
				</div>
			);
		}

		return (
			<div className={this.props.classes.subComponent}>
				<ReactTable
					data={row.original.historyList}
					columns={historyColumns}
					defaultPageSize={defaultPageSize}
					className="-striped -highlight"
					showPageSizeOptions={false}
				/>
			</div>
		);
	};

	/**
	 * 全カラム定義取得
	 */
	protected getAllColumns(): any[] {
		return [
			{
				Header: i18n.t('TestQuestionnaireHistory_0003'),
				accessor: 'title',
				width: 300,
			},
			{
				Cell: (row: RowRenderProps) =>
					i18n.t(row.value, { ns: 'force' }),
				Header: i18n.t('TestQuestionnaireHistory_0004'),
				accessor: 'kind',
				width: 100,
			},
			{
				Header: i18n.t('TestQuestionnaireHistory_0005'),
				accessor: 'historyCount',
				sortable: false,
				width: 200,
			},
		];
	}

	/**
	 * 全カラム定義取得
	 */
	protected getHistoryColumns(summary: Actions.IQuestionnaireSummary): any[] {
		if (summary.kind === 'テスト') {
			return [
				{
					Header: i18n.t('TestQuestionnaireHistory_0006'),
					accessor: 'startDate',
					width: 300,
				},
				{
					Header: i18n.t('TestQuestionnaireHistory_0007'),
					accessor: 'endDate',
					width: 300,
				},
				{
					Header: i18n.t('TestQuestionnaireHistory_0008'),
					accessor: 'tokuten',
					width: 100,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.disableFlg === 'false') {
							return (
								<Button
									variant="contained"
									color="primary"
									data-thistoryid={row.value}
									onClick={this.showTestHistory(
										summary,
										row.original
									)}
								>
									{i18n.t('TestQuestionnaireHistory_0009')}
								</Button>
							);
						} else {
							return '';
						}
					},
					Header: i18n.t('TestQuestionnaireHistory_0010'),
					accessor: 'thistoryId',
					sortable: false,
					width: 200,
				},
			];
		} else if (summary.kind === 'Scormテスト') {
			return [
				{
					Header: i18n.t('TestQuestionnaireHistory_0011'),
					accessor: 'startDate',
					width: 300,
				},
				{
					Header: i18n.t('TestQuestionnaireHistory_0012'),
					accessor: 'tokuten',
					width: 100,
				},
				{
					Header: i18n.t('TestQuestionnaireHistory_0013'),
					accessor: 'status',
					width: 100,
				},
			];
		} else {
			return [
				{
					Header: i18n.t('TestQuestionnaireHistory_0014'),
					accessor: 'enqueteUpdDate',
					width: 300,
				},
				{
					Cell: (row: RowRenderProps) => {
						if (row.original.disableFlg === 'false') {
							return (
								<Button
									variant="contained"
									color="primary"
									onClick={this.showQuestionnaireHistory}
								>
									{i18n.t('TestQuestionnaireHistory_0015')}
								</Button>
							);
						} else {
							return '';
						}
					},
					Header: i18n.t('TestQuestionnaireHistory_0016'),
					accessor: 'dummy',
					sortable: false,
					width: 200,
				},
			];
		}
	}

	/**
	 * テスト画面遷移処理
	 * @param e イベントオブジェクト
	 */
	protected showTestHistory = (
		summary: Actions.IQuestionnaireSummary,
		history: Actions.IQuestionnaireHistory
	) => (e: React.MouseEvent<HTMLButtonElement>) => {
		const { params } = this.props.match;

		let to = Routes.getPath(Screens.PERSONAL_TEST_RESULT);
		to = to.replace(/\/:career_id\//, `/${params.career_id}/`);
		to = to.replace(/\/:class_id\//, `/${params.class_id}/`);
		to = to.replace(/\/:test_id\//, `/${summary.id}/`);
		to = to.replace(/\/:thistory_id\//, `/${history.thistoryId}/`);
		to = to.replace(/\/:display_style/, `/${summary.displayStyle}`);

		this.props.pushHistory(to);
	};

	/**
	 * アンケート画面遷移処理
	 * @param e イベントオブジェクト
	 */
	protected showQuestionnaireHistory(e: React.MouseEvent<HTMLButtonElement>) {
		// const targetQuestionnaire = this.props.data[this.state.selectedIndex];
		// const { id as enqueteID } = targetQuestionnaire;
		// const { careerID, classID } = this.state;
	}
}

const mapStateToProps = (state: IRootState) => ({
	data: state.imstat.questionnaireHistory.data,

	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchQuestionnaireHistory: (
		token: string,
		arg: IFetchQuestionnaireHistoryParam
	) => {
		const s = ImstatScenarioFactory.createFetchQuestionnaireHistory(
			dispatch,
			token
		);
		s.run(arg);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	resetQuestionnaireHistoryData: () =>
		dispatch(Actions.setQuestionnaireHistoryData({ data: [] })),
});

// tslint:disable-next-line: no-empty-interface
export interface ITestQuestionnaireHistoryProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	ITestQuestionnaireHistoryProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(TestQuestionnaireHistory);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ITestQuestionnaireHistoryProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/TestQuestionnaireHistory.tsx